import { render, staticRenderFns } from "./PrivacyModal.vue?vue&type=template&id=1e647b36&scoped=true&"
import script from "./PrivacyModal.vue?vue&type=script&lang=js&"
export * from "./PrivacyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e647b36",
  null
  
)

export default component.exports